import googlePlayBadge from '../../assets/images/google-play-light-badge.svg';
import appStoreBadge from '../../assets/images/appstore-light-badge.svg';

// The same light store badges as on the old app pages
const StoreButtons = ({appStore, googlePlay}) => (
  <div className="store-buttons">
    <a className="store-badge store-badge--google" href={googlePlay} target="_blank" rel="noreferrer">
      <img src={googlePlayBadge} alt="Get it on Google Play"/>
    </a>
    <a className="store-badge store-badge--apple" href={appStore} target="_blank" rel="noreferrer">
      <img src={appStoreBadge} alt="Download on the App Store"/>
    </a>
  </div>
);

export default StoreButtons;
